import React, {Component} from 'react';
import { connect } from 'react-redux';
import ApplicationMessages from './ApplicationMessages';
import PROCESSING_STATS_CONTROLLER from '../../controllers/processingStats';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Modal from 'react-responsive-modal';
import ProcessingStatsDetails from '../countriesOnHold/ProcessingStatsDetails';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS}  from '../../utils/log';
import MessageLogger, { ALL_MESSAGES } from '../../utils/logger';

const log = new Logger('ProcessingStatsMessage', LOG_LEVELS.DEBUG);
const messageLog = new MessageLogger('ProcessingStatsMessage', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width modal-max-width-65'
};
export class ProcessingStatsMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showInfoMessage: false,
            showModal: false
        };
        this.getNotificationMessage = this.getNotificationMessage.bind(this);
        this.onMessageClickHandler = this.onMessageClickHandler.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.refreshStats = this.refreshStats.bind(this);
    }

    openModal() {
        this.setState({ 
            showModal: true
        });
    }

    closeModal() {
        this.refreshStats();
        this.setState({
            showModal: false
        });
    }

    refreshStats() {
        //Remove old message
        this.setState({showInfoMessage: false});
        messageLog.clearDictionaryError(ALL_MESSAGES.TRANSACTIONS_PENDING);
        messageLog.clearDictionaryError(ALL_MESSAGES.DOCUMENTS_ON_HOLD);
        //Get updated stats
        this.props.doResetHideFurtherNotification(()=>{
            this.props.getProcessingStats();
        });
    }

    getNotificationMessage(onHoldCount=0, pendingCount=0) {
        let message = '';
        if(onHoldCount > 0) {
            message = `${LANGUAGES_CONTROLLER.format(this.props.languages, 'processingStats_TransactionsOnHold', onHoldCount)}`;
        }
        if(pendingCount > 0) {
            if(message.length > 0) {
                message = `${message} `;
            }
            message = `${message}${LANGUAGES_CONTROLLER.format(this.props.languages, 'processingStats_TransactionsPending', pendingCount)}`
        }
        return message;
    }

    componentDidMount() {
        this.props.getProcessingStats();
    }

    componentDidUpdate(prevProps) {
      if(prevProps.processingStats !== this.props.processingStats) {
            const { transactionsPending=0, transactionsOnHold=0} = this.props.processingStats || {};
            //Show info message in case of any count
            if(this.props.hideFurtherNotification === false && (transactionsOnHold > 0 || transactionsPending > 0)) {
                if(!this.state.showInfoMessage) {
                    this.setState({
                        showInfoMessage: true
                    });
                    let notificationMessage = this.getNotificationMessage(transactionsOnHold, transactionsPending);

                    if( transactionsPending > 0)
                    {
                        messageLog.clearDictionaryError(ALL_MESSAGES.DOCUMENTS_ON_HOLD);
                        messageLog.setDictionaryMessage(ALL_MESSAGES.TRANSACTIONS_PENDING, notificationMessage);
                    }
                   else {
                        messageLog.clearDictionaryError(ALL_MESSAGES.TRANSACTIONS_PENDING);
                        messageLog.setDictionaryMessage(ALL_MESSAGES.DOCUMENTS_ON_HOLD, notificationMessage);
                    } 
                    this.props.doHideFurtherNotification();
                }
            } 
        }
    }

    onMessageClickHandler() {
        log.debug('onMessageClickHandler()');
        this.openModal();
    }

    render() {
        log.debug('render():', this.props);
        if(!this.state.showInfoMessage) {
            return (
                <div data-test ="component-processing-stats-message-no-display"></div>
            );
        };
        
        return (
            <div data-test ="component-processing-stats-message">
                 <ApplicationMessages
                    messageType="applicationInfo" 
                    messageIds={[ALL_MESSAGES.DOCUMENTS_ON_HOLD]} 
                    tooltipWithParams={false} 
                    tooltipOffset={{right: 250}} 
                >
                      <span>
                          &nbsp;<a onClick={this.onMessageClickHandler}>
                              <LanguageStringResolver string="ProcessingStats_SeeDetails"/>
                         </a>
                      </span>
                </ApplicationMessages>
                <Modal 
                    open={this.state.showModal} 
                    onClose={this.closeModal} 
                    classNames={MODAL_CLASSNAMES} 
                    closeOnEsc={true} 
                    blockScroll={true}
                    closeOnOverlayClick={false} 
                >
                    <h2><LanguageStringResolver string="ProcessingStats_TransactionsOnHold"/></h2>
                    <ProcessingStatsDetails />
                </Modal>
                <ApplicationMessages 
                    messageType="applicationInfo" 
                    messageIds={[ALL_MESSAGES.TRANSACTIONS_PENDING]} 
                    tooltipWithParams={false} 
                    tooltipOffset={{right: 250}}
                />
            </div>
        );
    }

    componentWillUnmount() {
        this.props.unload();
    }
}


let mapStatToProps = function(state) {
    return {
        languages: state.languages,
        processingStats: state.processingStats.data,
        hideFurtherNotification: state.processingStats.hideFurtherNotification
    };
}

let mapDispatcherToProps = function(dispatch) {
    return {
        getProcessingStats: () => {
            dispatch(PROCESSING_STATS_CONTROLLER.doGetProcessingStats());
        },
        unload: () => {
            dispatch(PROCESSING_STATS_CONTROLLER.doUnload());
        },
        doHideFurtherNotification: () => {
            dispatch(PROCESSING_STATS_CONTROLLER.doHideFurtherNotification());
        },
        doResetHideFurtherNotification: (callback) => {
            dispatch(PROCESSING_STATS_CONTROLLER.doResetHideFurtherNotification(callback));
        }
    }
}

export default connect(mapStatToProps, mapDispatcherToProps)(ProcessingStatsMessage);
